import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import { type DealFormData, dealFormField } from '@openx/types/deal.ts';
import type { JSX } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { generatedIdTypes } from './enums.ts';
import { StyledBoxMargined, StyledFormControlMargined } from './styled/index.ts';

export const IdPreview = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { control } = useFormContext<DealFormData>();
  const observableGeneratedPrefix = useWatch({
    control,
    name: `${dealFormField.GENERATED_DEAL_ID_PREFIX}`,
  });

  return observableGeneratedPrefix !== generatedIdTypes.Default ? (
    <StyledFormControlMargined data-test="radio-generated-preview" fullWidth margin="dense">
      <FormLabel>{t('Deal ID')}</FormLabel>
      <StyledBoxMargined data-test="radio-generated-preview-value">
        <Typography
          variant="body1Bold"
          component="span"
          sx={{
            display: 'inline',
          }}
        >
          {observableGeneratedPrefix}
        </Typography>
        <Typography
          variant="body1"
          component="span"
          color="text.disabled"
          sx={{
            display: 'inline',
          }}
        >
          {'xxxxxx'}
        </Typography>
      </StyledBoxMargined>
    </StyledFormControlMargined>
  ) : null;
};
